export default __webpack_public_path__ + "static/media/15.5d0e5cd5.jpg";